import { useEffect, useState } from 'react'
import Dashboard from '../../components/Dashboard'
import ProductosTable from '../../components/Productos/Table'
import useFetchHome from '../../hooks/useFetchHome'
import { getProductos } from '../../services/productos/productos'
import { Button, TextField, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const ProductosPage = () => {

    const [productos, setProductos] = useState<any[]>([])
    const [productosFiltrados, setProductosFiltrados] = useState<any[]>([])
    const [filtroBusqueda, setFiltroBusqueda] = useState('')
    const {home} = useFetchHome()
    const navigate = useNavigate()

    useEffect(() => {

      const fetchProductos = async () => {
        const productosDB = await getProductos()
        setProductos(productosDB)
        setProductosFiltrados(productosDB)
      }

      
      fetchProductos()
    },[])


    useEffect(() => {
      if (filtroBusqueda.trim() === '') {
        setProductosFiltrados(productos)
      } else {
        const filtrados = productos.filter(producto => 
          producto.nombre.toLowerCase().includes(filtroBusqueda.toLowerCase()) ||
          producto.sku.toLowerCase().includes(filtroBusqueda.toLowerCase())
        )
        setProductosFiltrados(filtrados)
      }
    }, [filtroBusqueda, productos])

    

  return (
    <Dashboard>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        margin:'2% 0'
      }}>
      <h1>PRODUCTOS</h1>
      
      
      <Button variant='contained' color='success' style={{
          marginBottom: '20px',
          background: '#000',
          fontFamily: 'WorkSans',
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '16px',
          textAlign: 'center',
          textTransform: 'uppercase',
          color: '#FFF',
          padding: '17px 62px',
          border: 'none',
          cursor: 'pointer',
        }} onClick={() => {
          navigate("/producto/nuevo")
        }} >
          Nuevo Producto
        </Button>
      </div>

      <Box sx={{ marginBottom: '20px', maxWidth: '400px' }}>
        <TextField
          fullWidth
          label="Buscar por nombre o SKU"
          variant="outlined"
          value={filtroBusqueda}
          onChange={(e) => setFiltroBusqueda(e.target.value)} 
          placeholder="Ingresa el nombre del producto o SKU..."
        />
      </Box>

      {/* Información de resultados */}
      <Box sx={{ marginBottom: '10px', fontSize: '14px', color: '#666' }}>
        {filtroBusqueda.trim() !== '' 
          ? `Mostrando ${productosFiltrados.length} de ${productos.length} productos`
          : `Total: ${productos.length} productos`
        }
      </Box>
      
        <ProductosTable productos={productosFiltrados} home={home}   />
    </Dashboard>
  )
}

export default ProductosPage